function lazyImageBackgrounds() {
  document.addEventListener('lazyloaded', function (e) {
    const lazyImage = e.target.parentNode;
    if (lazyImage.classList.contains('lazy-image')) {
      lazyImage.style.backgroundImage = 'none';
    }
  });
}

export {lazyImageBackgrounds};
